import { MenuItem, Select, Typography } from '@mui/material';
import { REPORT_RANGE } from '@consts/reports';

interface SelectRangeProps {
    updateRange: (range: string) => void;
    range: string;
}

export const SelectRange = ({ updateRange, range }: SelectRangeProps) => {
    return (
        <Select value={range} onChange={(e) => updateRange(e.target.value)} variant='outlined' style={{ maxHeight: '38px' }}>
            {Object.values(REPORT_RANGE).map((range) => (
                <MenuItem key={range} value={range} style={{ outline: 0 }}>
                    <Typography sx={{ textTransform: 'capitalize' }}>{range}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
};
